<template>
  <div class="costDeptDataSingle">
    <div class="mainContentWrap mainContentWrap22">
      <el-row>
        <!--                <el-col :span="13" :offset="5">-->
        <el-col :span="24">
          <div class="title">{{ deptName }}</div>
          <div class="unitClass">单位：元</div>
          <div class="top">
            <el-row>
              <el-col :span="10">
                <div class="top_sum">
                  总收入
                  <br />
                  {{ formatCurrency(earningAmount) }}
                </div>
                <div class="top_sum top_sum1">
                  毛利
                  <br />
                  {{ formatCurrency(grossProfitAmount) }}
                </div>
              </el-col>
              <el-col :span="14">
                <div class="echart1" id="echart42Top"></div>
              </el-col>
            </el-row>
          </div>
          <div class="middle">
            <div class="title">项目分布情况</div>
            <div class="echarts2Wrap">
              <div class="echarts2Conents">
                <div class="echart_legend">
                  <span class="colorBox colorBox1"></span><span>收入</span>
                  <span class="colorBox colorBox2"></span><span>成本</span>
                  <span class="colorBox colorBox3"></span><span>毛利</span>
                </div>
                <div class="echart2" id="echart42Center"></div>
                <div class="centerTable">
                  <el-table :data="projectTableData" size="mini" border>
                    <el-table-column
                      prop="aaaa"
                      label
                      width="140"
                      :resizable="false"
                    >
                      <template slot-scope="scope">
                        <span
                          class="tableSpan"
                          :style="{
                            background:
                              scope.$index == 0
                                ? '#3F95C2'
                                : scope.$index == 1
                                ? '#6DC8E1'
                                : '#4EB2D4',
                          }"
                        ></span>
                        <span>{{ scope.row[scope.column.property] }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      v-for="(item, index) in grossProfitProjectVOList"
                      :prop="'column' + index"
                      :label="item.projectName ? item.projectName : ''"
                      :key="index + Math.random()"
                      show-overflow-tooltip
                      :resizable="false"
                    >
                      <template slot="header">
                        <el-popover trigger="hover" placement="top">
                          <span>{{ item.projectName }}</span>
                          <!--hover的内容 -->
                          <div
                            slot="reference"
                            style="
                              padding: 0px;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              white-space: nowrap;
                            "
                          >
                            <span>{{ item.projectName }}</span>
                            <!--显示的内容-->
                          </div>
                        </el-popover>
                      </template>
                      <template slot-scope="scope">
                        {{ formatCurrency(scope.row[scope.column.property]) }}
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="bottom">
                        <el-row>
                            <el-col :span="14">
                                <div class="title">欠款金额明细分析</div>
                                <div class="echart1" id="echart42BottomLeft"></div>
                            </el-col>
                            <el-col :span="10">
                                <div class="title">按帐龄划分金额</div>
                                <div class="echart1" id="echart42BottomRight"></div>
                            </el-col>
                        </el-row>
                    </div> -->
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getProfitCostAmountDept } from "@/services/dataCenterAService";

var echarts = require("echarts/lib/echarts");
// 引入柱状图
require("echarts/lib/chart/bar");
require("echarts/lib/chart/pie");
require("echarts/lib/chart/line");
// 引入提示框和标题组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
export default {
  // name: "costDeptDataSingle",
  props: ["isFullscreen"],
  data() {
    return {
      //顶部数据
      deptName: "",
      sumdata: {},
      earningAmount: "",
      grossProfitAmount: "",
      //中间部分数据
      grossProfitProjectVOList: [],
      echartsSumData: [],
      echartsSumDataName: [],
      projectTableData: [],
      echart42Center: null,
      echart42: null,
      echart42BottomLeft: null,
      echart42BottomRight: null,
    };
  },

  methods: {
    setWrapHeight() {
      let cww = document.getElementsByClassName("costTotalWrap")[0].offsetWidth;
      let ch = Math.ceil((1360 / 900) * cww * 0.98);
      if (document.getElementById("aside")) {
        ch = 1360;
        document.getElementsByClassName("costDeptDataSingle")[0].style.width =
          "900px";
      }
      document.getElementsByClassName("costDeptDataSingle")[0].style.height =
        ch + "px";
      console.log("子组件变化");
      if (this.echart42Center) {
        this.echart42Center.resize();
      }
      if (this.echart42) {
        this.echart42.resize();
      }
      // if (this.echart42BottomLeft) {
      //   this.echart42BottomLeft.resize();
      // }
      // if (this.echart42BottomRight) {
      //   this.echart42BottomRight.resize();
      // }
    },
    search(searchData) {
      let _this = this;
      //查询项目部下的数据
      let params = {};
      if (searchData.yearMonth) {
        params.yearMonth = searchData.yearMonth;
      }
      // if (searchData.projectProcess) {
      //   params.projectProcess = searchData.projectProcess;
      // }
      if (searchData.deptId) {
        params.deptId = searchData.deptId;
      }
      getProfitCostAmountDept(params)
        .then((res) => {
          if (res.code === 10000000) {
            _this.deptName = searchData.deptName;
            //顶部部分数据
            _this.sumdata = res.data;
            _this.earningAmount = res.data.earningAmount;
            _this.grossProfitAmount = res.data.grossProfitAmount;
            // 中间部分数据
            _this.grossProfitProjectVOList = res.data
              .grossProfitProjectVOList || [
              {
                earningAmount: 0,
                costAmount: 0,
                grossProfitAmount: 0,
                costPct: "0",
                grossProfitPct: "0",
              },
            ];
            if (res.data.grossProfitProjectVOList.length < 1) {
              _this.grossProfitProjectVOList = [
                {
                  earningAmount: 0,
                  costAmount: 0,
                  grossProfitAmount: 0,
                  costPct: "0",
                  grossProfitPct: "0",
                  projectName: "",
                },
              ];
            }

            // _this.grossProfitProjectVOList.unshift({});
            _this.echartsSumData = [[], [], []];
            _this.echartsSumDataName = [];
            // 中间柱状图
            _this.grossProfitProjectVOList.forEach((item, index) => {
              _this.echartsSumData[0].push(item.earningAmount);
              _this.echartsSumData[1].push(item.costAmount);
              _this.echartsSumData[2].push(item.grossProfitAmount);
              _this.echartsSumDataName.push(item.projectName);
            });
            //中间table表格
            _this.projectTableData = [
              {
                aaaa: "收入",
              },
              {
                aaaa: "成本",
              },
              {
                aaaa: "毛利",
              },
            ];
            _this.echartsSumData.forEach((item, index) => {
              item.forEach((subItem, subIndex) => {
                _this.projectTableData[index]["column" + subIndex] = subItem;
              });
            });
            this.$nextTick(() => {
              let centerParams = {
                // costAmount: this.sumdata.collectedMoneyTotal,
                // grossProfitAmount: this.sumdata.grossProfitAmount,
                grossProfitAmount: _this.sumdata.grossProfitAmount, //总毛利
                grossProfitPct: _this.sumdata.grossProfitPct, //总毛利百分比
                costAmount: _this.sumdata.costAmount, //总成本
                costPct: _this.sumdata.costPct, //总成本百分比
                directCostAmount: _this.sumdata.directCostAmount, //直接成本
                directCostPct: _this.sumdata.directCostPct, //直接成本百分比
                inDirectCostAmount: _this.sumdata.inDirectCostAmount, //间接成本
                inDirectCostPct: _this.sumdata.inDirectCostPct, //间接成本百分比
              };
              this.draw(centerParams, "Top"); //顶部饼状图 aaaa已收款
              this.drawCenter(); //中间柱状图
              if (this.echart42Center) {
                this.echart42Center.resize();
              }
              // this.setWrapHeight()
              // let bottomLeftParams = [
              //     {value: this.sumdata.retentionMoney, name: "质保金"},
              //     {
              //         value: this.sumdata.projectMoney,
              //         name: "需交工验收、审计、竣工验收后应支付工程款(不含质保金)"
              //     },
              //     {
              //         value: this.sumdata.processMoney,
              //         name:
              //             "按进度应支付工程款(欠款总额-质保金-需交工验收、审计、竣工验收后应支付工程款)"
              //     }
              // ];
              // this.drawBottomLeft(bottomLeftParams); //底部左边饼状图
              // this.drawBottomRight(); //底部右边饼状图
            });
          } else if (res.code > 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$message.error("系统异常");
          }
        })
        .catch((error) => {
          this.$message.error("系统异常");
        });
    },
    //    绘制顶部饼状图
    draw(item, index) {
      let _this = this;
      console.log(index);
      let idName = "echart42" + index;
      // let myChart = echarts.init(document.getElementById(idName));
      this.echart42 = echarts.init(document.getElementById(idName));
      let option = {
        title: {
          show: false,
        },
        tooltip: {
          trigger: "item",
          showDelay: 20, // 显示延迟，添加显示延迟可以避免频繁切换，单位ms
          hideDelay: 20, // 隐藏延迟，单位ms
          textStyle: {
            fontSize: "16px",
            color: "#fff", // 设置文本颜色 默认#FFF
          },
          formatter:  function (params) {
                  let txt = "";
                  txt = _this.getPecent(params.name, index);
                  return txt;
                },
        },
        legend: {
          orient: "horizontal",
          icon: "rect",
          bottom: 20,
          itemHeight: 8,
          itemWidth: 12,
          left: "center",
          data: [ "毛利","直接成本", "间接成本"],
        },
        color: ["#4EB2D4","#6DC8E1","#3F95C2"],
        series: [
          {
            name: "",
            type: "pie",
            radius: "55%",
            center: ["50%", "40%"],
            data: [
            { value: item.grossProfitAmount, name: "毛利" },
            { value: item.directCostAmount, name: "直接成本" },
              { value: item.inDirectCostAmount, name: "间接成本" },
              
            ],

            // 设置值域的那指向线
            labelLine: {
              normal: {
                show: false, // show设置线是否显示，默认为true，可选值：true ¦ false
              },
            },
            // 设置值域的标签
            label: {
              normal: {
                padding: [0, -10],
                textStyle: {
                  fontSize: 14,
                  color: "rgba(0,0,0,0.8)",
                },
                // formatter: "{b}\n{d}%"
                formatter: function (params) {
                  let txt = "";
                  txt =
                    params.name +
                    "\n" +
                    _this.getPecent(params.name, index) +
                    "\n" +
                    _this.formatCurrency(params.value);
                  return txt;
                },
              },
            },
          },
        ],
      };
      this.echart42.setOption(option);
    },
    //绘制中间柱状图
    drawCenter() {
      //先设置表格的宽度
      let wrapWidth =
        document.getElementsByClassName("echarts2Wrap")[0].offsetWidth;
      if (this.grossProfitProjectVOList.length * 150 + 200 < wrapWidth) {
        document.getElementsByClassName("echarts2Conents")[0].style.width =
          wrapWidth + "px";
      } else {
        let widthC = 200 + this.grossProfitProjectVOList.length * 150;
        document.getElementsByClassName("echarts2Conents")[0].style.width =
          widthC + "px";
      }

      this.echart42Center = echarts.init(
        document.getElementById("echart42Center")
      );
      let option = {
        legend: {
          // data: ["审计额或已完成产值", "已收款", "应收账款"],
          data: [],
          orient: "horizontal",
          bottom: 0,
          itemHeight: 0,
          itemWidth: 0,
          left: "center",
        },
        grid: {
          left: 150,
          right: 80,
          bottom: 0,
          top: 20,
          containLabel: true,
        },
        tooltip: {
          show: false,
        },
        color: ["#3F95C2", "#6DC8E1", "#4EB2D4"],
        xAxis: {
          show: false,
          data: this.echartsSumDataName,
          axisLine: {
            // 坐标轴 轴线
            show: false, // 是否显示
          },
          axisTick: {
            // 坐标轴的刻度
            show: false, // 是否显示
          },
          label: {
            show: false,
          },
        },
        yAxis: {
          show: true, // 是否显示
          type: "value", // 轴类型，默认为 ‘category’
          axisLine: {
            // 坐标轴 轴线
            show: false, // 是否显示
          },
          axisTick: {
            // 坐标轴的刻度
            show: false, // 是否显示
          },
          min: 0,
        },
        series: [
          {
            name: "收入",
            type: "bar",
            barWidth: 16, // 柱形的宽度
            data: this.echartsSumData[0],
          },
          {
            name: "成本",
            type: "bar",
            barWidth: 16, // 柱形的宽度
            data: this.echartsSumData[1],
          },
          {
            name: "毛利",
            type: "bar",
            barWidth: 16, // 柱形的宽度
            data: this.echartsSumData[2],
          },
        ],
      };
      this.echart42Center.setOption(option);
    },
    //绘制底部左边圆形图
    drawBottomLeft(bottomLeftParams) {
      let _this = this;
      this.echart42BottomLeft = echarts.init(
        document.getElementById("echart42BottomLeft")
      );
      let option = {
        title: {
          show: false,
        },
        tooltip: {
          trigger: "item",
          showDelay: 20, // 显示延迟，添加显示延迟可以避免频繁切换，单位ms
          hideDelay: 20, // 隐藏延迟，单位ms
          textStyle: {
            fontSize: "16px",
            color: "#fff", // 设置文本颜色 默认#FFF
          },
          formatter: "{c}",
        },
        legend: {
          // orient: 'horizontal',
          orient: "vertical",
          icon: "circle",
          bottom: 15,
          itemHeight: 5,
          itemWidth: 5,
          left: "center",
          data: [
            "质保金",
            "需交工验收、审计、竣工验收后应支付工程款(不含质保金)",
            "按进度应支付工程款(欠款总额-质保金-需交工验收、审计、竣工验收后应支付工程款)",
          ],
        },
        color: ["#f79646", "#4bacc6", "#8064a2"],
        // b65708
        series: [
          {
            name: "",
            type: "pie",
            radius: "46%",
            center: ["50%", "40%"],
            data: bottomLeftParams,
            // data: [
            //     {value: this.sumdata.retentionMoney, name: '质保金'},
            //     {value: this.sumdata.projectMoney, name: '需交工验收、审计、竣工验收后应支付工程款/(不含质保金)'},
            //     {value: this.sumdata.processMoney, name: '按进度应支付工程款(欠款总额-质保金-需交工验收、审计、竣工验收后应支付工程款)'},
            // ],
            // 设置值域的那指向线
            labelLine: {
              normal: {
                show: false, // show设置线是否显示，默认为true，可选值：true ¦ false
              },
            },
            // 设置值域的标签
            label: {
              normal: {
                padding: [0, -20],
                textStyle: {
                  fontSize: 12,
                  color: "rgba(0,0,0,0.8)",
                },
                // formatter: "{c}"
                formatter: function (params) {
                  return _this.formatCurrency(params.value);
                },
              },
            },
          },
        ],
      };
      this.echart42BottomLeft.setOption(option);
    },
    //绘制底部右边圆形图
    drawBottomRight() {
      let _this = this;
      this.echart42BottomRight = echarts.init(
        document.getElementById("echart42BottomRight")
      );

      let option = {
        title: {
          show: false,
        },
        tooltip: {
          trigger: "item",
          showDelay: 20, // 显示延迟，添加显示延迟可以避免频繁切换，单位ms
          hideDelay: 20, // 隐藏延迟，单位ms
          textStyle: {
            fontSize: "16px",
            color: "#fff", // 设置文本颜色 默认#FFF
          },
          formatter: "{c}",
        },
        legend: {
          orient: "horizontal",
          icon: "circle",
          bottom: 20,
          itemHeight: 5,
          itemWidth: 5,
          left: "center",
          data: ["1年以内", "1-2年", "2-3年", "3年(含)以上"],
        },
        color: ["#f79646", "#4bacc6", "#8064a2", "#b65708"],
        series: [
          {
            name: "",
            type: "pie",
            radius: "50%",
            center: ["50%", "40%"],
            data: [
              { value: this.sumdata.withinOneYear, name: "1年以内" },
              { value: this.sumdata.oneToTwo, name: "1-2年" },
              { value: this.sumdata.twoToThree, name: "2-3年" },
              { value: this.sumdata.beyondThree, name: "3年(含)以上" },
            ],
            // 设置值域的那指向线
            labelLine: {
              normal: {
                show: false, // show设置线是否显示，默认为true，可选值：true ¦ false
              },
            },
            // 设置值域的标签
            label: {
              normal: {
                padding: [0, -20],
                textStyle: {
                  fontSize: 12,
                  color: "rgba(0,0,0,0.8)",
                },
                // formatter: "{c}"
                formatter: function (params) {
                  return _this.formatCurrency(params.value);
                },
              },
            },
          },
        ],
      };
      this.echart42BottomRight.setOption(option);
    },
    getPecent(name, index) {
      console.log(index);
      if (index == "Top") {
        switch (name) {
          case "毛利":
            return this.sumdata.grossProfitPct;
          case "直接成本":
            return this.sumdata.directCostPct;
            case "间接成本":
            return this.sumdata.inDirectCostPct;
        }
      } else {
        switch (name) {
          case "毛利":
            return this.auditAmountDeptList[index - 1].grossProfitPct;
          case "直接成本":
            return this.auditAmountDeptList[index - 1].directCostPct;
            case "间接成本":
            return this.auditAmountDeptList[index - 1].inDirectCostPct;
        }
      }
    },
    //数字用逗号隔开
    formatCurrency(num) {
      num = Number(num);
      num = num.toFixed(2);
      if (num === 0) {
        return 0;
      } else if (num) {
        num = num.toString().replace(/\$|\,/g, "");
        if (num === "" || isNaN(num)) {
          return 0;
        }
        var sign = "";
        if (num.indexOf("-") !== -1) {
          sign = "-";
          num = num.substr(1);
        }
        var cents = num.indexOf(".") > 0 ? num.substr(num.indexOf(".")) : "";
        cents = cents.length > 1 ? cents : "";
        num = num.indexOf(".") > 0 ? num.substring(0, num.indexOf(".")) : num;
        if (cents === "") {
          if (num.length > 1 && num.substr(0, 1) === "0") {
            return 0;
          }
        } else {
          if (num.length > 1 && num.substr(0, 1) === "0") {
            return 0;
          }
        }
        for (var i = 0; i < Math.floor((num.length - (1 + i)) / 3); i++) {
          num =
            num.substring(0, num.length - (4 * i + 3)) +
            "," +
            num.substring(num.length - (4 * i + 3));
        }
        return sign + num + cents;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.costDeptDataSingle {
  width: 98%;
  text-align: left;
  overflow: hidden;
  background: #ffffff;
  padding: 0 10px;
  height: 1360px;
  margin: 0 auto;

  .mainContentWrap {
    height: 100%;
    margin: 0 auto;

    .el-row {
      height: 100%;

      .el-col {
        height: 100%;

        .title {
          text-align: center;
          font-size: 24px;
          line-height: 50px;
          font-weight: 600;
        }

        .unitClass {
          text-align: right;
          font-size: 20px;
        }

        .top {
          width: calc(100% - 10px);
          border: 1px solid #c8c8c8;
          /*height: calc(26% - 36px);*/
          /*height: 284px;*/
          height: 21%;
          margin: 10px 5px;
          padding-top: 4px;

          .el-row {
            height: 100%;

            .el-col {
              height: 100%;

              .top_sum {
                text-align: center;
                height: 40%;
                font-size: 16px;
                font-weight: 600;
                line-height: 10px;
                background: #6dc8e1;
                width: 80%;
                margin: 4% auto 4%;
              }

              .top_sum1 {
                background: #4eb2d4;
                margin: 0 auto;
              }

              .top_sum::before {
                display: inline-block;
                content: "";
                height: 60%;
                vertical-align: middle;
              }

              .echart1 {
                height: 100%;
              }
            }
          }
        }

        .middle {
          width: calc(100% - 10px);
          border: 1px solid #c8c8c8;
          /*height: calc(46% - 10px);*/
          /*height: 512;*/
          height: 38%;
          margin: 10px 5px;
          position: relative;

          .title {
            text-align: left;
            font-weight: 600;
            font-size: 16px;
            line-height: 16px;
            margin: 10px 0 0px 10px;
          }

          .echarts2Wrap {
            height: calc(100% - 26px);
            width: 100%;
            overflow-x: auto;
            overflow-y: hidden;
            .echarts2Conents {
              height: 100%;
              .echart2 {
                width: 100%;
                height: calc(100% - 124px - 32px);
              }

              .echart_legend {
                text-align: center;
                position: absolute;
                top: 20px;
                width: 100%;
                .colorBox {
                  display: inline-block;
                  margin-right: 2px;
                  width: 8px;
                  height: 8px;
                  border-radius: 2px;
                }
                .colorBox1 {
                  background: #3f95c2;
                }
                .colorBox2 {
                  background: #6dc8e1;
                }
                .colorBox3 {
                  background: #4eb2d4;
                }
              }
            }
          }

          .centerTable {
            /*position: absolute;*/
            // width: calc(100% - 118px);
            /*top: 64%;*/
            /*left: 40px;*/
            padding: 0 80px 0 90px;
            overflow: hidden;

            /deep/ .el-table {
              overflow: hidden;
            }

            /deep/ .el-table tr {
              th {
                padding: 0;
                background: #ffffff;

                .cell {
                  text-align: center;
                  height: 30px;
                  line-height: 30px;
                  /*overflow: auto;*/
                  overflow: hidden; /*设置超出的部分进行影藏*/
                  text-overflow: ellipsis; /*设置超出部分使用省略号*/
                  white-space: nowrap; /*设置为单行*/
                  width: 100%;
                }
              }

              td {
                padding: 0;

                .cell {
                  text-align: center;
                  height: 30px;
                  line-height: 30px;
                  padding-left: 0px;

                  .tableSpan {
                    display: inline-block;
                    margin-right: 2px;
                    width: 8px;
                    height: 8px;
                    border-radius: 2px;
                  }
                }
              }

              td:nth-of-type(1) .cell {
                text-align: left;
              }
            }
          }
        }

        .bottom {
          width: calc(100% - 10px);
          border: 1px solid #c8c8c8;
          /*height: calc(34% - 10px);*/
          /*height: calc(26% - 10px);*/
          /*height: 420px;*/
          height: 31%;
          margin: 10px 5px;

          .el-row {
            height: 100%;

            .el-col {
              height: 100%;

              .title {
                text-align: left;
                font-size: 16px;
                font-weight: 600;
                line-height: 16px;
                margin: 10px 0 10px 10px;
              }

              .echart1 {
                height: calc(100% - 36px);
              }
            }
          }
        }
      }
    }
  }
}
</style>

